<div class="wrapper" id="pageContentWrapper">
	<div class="overlay"></div>
	<router-outlet></router-outlet>

	@if (aiSmartSearchEnabled) {
		@if (isAgentUIEnabled) {
			<mfe-agent-ui mode="floating" open="false" [attr.config]="learnerAgentUiConfig"></mfe-agent-ui>
		} @else {
			<angie-lua-ai-smart-search></angie-lua-ai-smart-search>
		}
	} @else if (adminAgentEnabled && !hasDockedAgent()) {
		<mfe-agent-ui mode="floating" open="false" [attr.config]="adminAgentUiConfig"></mfe-agent-ui>
	}
</div>

<angie-journey-creation-loader></angie-journey-creation-loader>
